export default __webpack_public_path__ + "static/media/Miguel-Buencamino.ca2d4a91.jpg";